import { Grid, Box } from '@mui/material'

// Types
import type { StepProps } from '@/types/components/atoms/items/step'

const StepAtom = (props: StepProps) => {
	// Props
	const { isActive } = props

	return (
		<Grid size="auto" height={{ xs: 24, md: 44 }} width={{ xs: 24, md: 44 }} my={{ xs: 0, md: -1.25 }} position="relative">
			<Box
				className={`step-atom${isActive ? ' active' : ''}`}
				width={{ xs: 18, md: 24 }}
				height={{ xs: 18, md: 24 }}
				position="absolute"
				top="50%"
				left="50%"
				bgcolor="primary.main"
				borderRadius={3}
				sx={{
					zIndex: 1,
					transform: 'translate(-50%, -50%)',
					transition: 'all .3s ease',
					...(isActive && {
						bgcolor: 'transparent',
						outlineStyle: 'solid',
						outlineWidth: { xs: 5, md: 10 },
						outlineColor: 'primary.main'
					})
				}}
			/>
		</Grid>
	)
}

export default StepAtom
